import React from "react";

const Customers = () => {
  return <h1>customers</h1>;
};

export default Customers;
